import axios from "axios";
import { endpoint } from "../../config";
import { customToast } from "../../lib/toastLib";

const normalizeActivity = (activity) => ({
  activityId: activity.activityId,
  categoryId: activity.categoryId || null,
  visualizationId: activity.visualizationId || null,
  reportDisplayName: activity.reportDisplayName || "",
  reportingStartAtUtc: activity.reportingStartAtUtc || null,
  reportingEndAtUtc: activity.reportingEndAtUtc || null,
  durationSeconds:
    typeof activity.durationSeconds === "number"
      ? activity.durationSeconds
      : null,
});

const normalizeSession = (session) => ({
  sessionId: session.sessionId,
  userId: session.userId,
  userFullName: session.userFullName || "",
  userEmail: session.userEmail || "",
  loginAtUtc: session.loginAtUtc || null,
  logoutAtUtc: session.logoutAtUtc || null,
  sessionStatus: session.sessionStatus || "",
  logoutReason: session.logoutReason || "",
  lastSeenAtUtc: session.lastSeenAtUtc || null,
  activities: Array.isArray(session.activities)
    ? session.activities.map(normalizeActivity)
    : [],
});

const sessionReportApi = async ({
  page = 1,
  pageSize = 10,
  startDate = "",
  endDate = "",
} = {}) => {
  try {
    const response = await axios.get(`${endpoint}/api/session/report`, {
      params: {
        page,
        pageSize,
        ...(startDate ? { startDate } : {}),
        ...(endDate ? { endDate } : {}),
      },
    });

    return {
      items: Array.isArray(response.data?.items)
        ? response.data.items.map(normalizeSession)
        : [],
      pagination: {
        page: response.data?.pagination?.page || page,
        pageSize: response.data?.pagination?.pageSize || pageSize,
        totalSessions: response.data?.pagination?.totalSessions || 0,
        totalPages: response.data?.pagination?.totalPages || 1,
      },
      period: {
        start: response.data?.period?.start || null,
        end: response.data?.period?.end || null,
        isDefaultLast7Days: Boolean(response.data?.period?.isDefaultLast7Days),
      },
    };
  } catch (error) {
    if (error.response) {
      customToast.error(error.response.data?.message);
    } else {
      customToast.error(error.message);
    }
    throw error;
  }
};

export default sessionReportApi;
